import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from 'src/app/services/chat.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalMsgStartChatWhatsappComponent } from '../modal-msg-start-chat-whatsapp/modal-msg-start-chat-whatsapp.component';


@Component({
  selector: 'app-modal-cliente-contato',
  templateUrl: './modal-cliente-contato.component.html',
  styleUrls: ['./modal-cliente-contato.component.scss']
})
export class ModalClienteContatoComponent implements OnInit, OnDestroy {
  @Input() data;

  clientes: any = [];
  numero_contato: any = null;
  nome_contato: any = null;
  clienteSelecionado: any = null;
  newSubs: Subscription;
  hasIntegracao: boolean = false;
  provider_id: number;

  constructor(
    private modal: NgbActiveModal,
    private chatService: ChatService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private whatsappService: WhatsappService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.clientes = this.data.clientes;
    this.numero_contato = this.data.celular;
    this.nome_contato = this.data.nome_contato;
    this.verificaIntegracao();
  }

  ngOnDestroy(): void {
    
  }

  close(): void {
      this.modal.close();
  }

  iniciarConversa(): void {

    if(!this.hasIntegracao) {
          Swal.fire({
            title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
            icon: 'info',
            confirmButtonText: "Ok",
            position: "top"
          });
    
          return;
    }
    
    this.newSubs = this.chatService.obterIntegracaoAtivaSaida()
      .subscribe({
        next: (results) => {
          if(results.dropDown.length) {
            if(!results.filasAtivas.length) {
              Swal.fire({
                title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_FILA'),
                icon: 'info',
                confirmButtonText: 'Ok',
                position: 'top'
              });
              return;
            } else if(!results.integracoes.length) {
              Swal.fire({
                title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_NUM_SAIDA'),
                icon: 'info',
                confirmButtonText: 'Ok',
                position: 'top'
              });
              return;
            } else {
              const modalRef = this.modalService.open(ModalMsgStartChatWhatsappComponent, {
                scrollable: true,
                windowClass: 'modal-custom-milvus',
                size: 'medio',
                keyboard: true,
                backdrop: 'static',
                centered: true
              });
    
              let data = {
                provider_id: results.provider_id,
                number: this.numero_contato,
                integration_id: results.id,
                ...results
              };
              
              if(results.provider_id === 2) {
                data['message'] = results.mensagem_inicia_conversa_whatsapp
              };
    
              modalRef.componentInstance.data = data;
              modalRef.result.then(
                (result) => {
                  if(result && result.provider_id) {
                    var _contato = result;
    
                    _contato.from = results.numero;
                    _contato.numero_destino = this.numero_contato;
                    _contato.contato_id = this.clienteSelecionado.id;
                    _contato.numero_contato = this.numero_contato;
                    _contato.chamado_id = null;
                    _contato.nome_contato = this.nome_contato;
                    _contato.contato_id = this.clienteSelecionado.id;
                    _contato.cliente_id = this.clienteSelecionado.cliente_id;
  
                    this.newSubs = this.whatsappService
                    .wppIniciarConversaUnificado(_contato)
                    .subscribe(
                      (results) => {
                        this.modal.close(results.chat);
                      }
                    );
                  }
                }
              )
            }
          } else {
            Swal.fire({
              title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
              icon: 'info',
              confirmButtonText: "Ok",
              position: "top"
            });
          }
        }
      });
  }

  verificaIntegracao() {
      this.newSubs = this.chatService.obterIntegracaoAtiva().subscribe(
        (result) => {
          result ? (this.hasIntegracao = true) : (this.hasIntegracao = false);
  
          this.provider_id = result.provider_id;
        }
      );
    }
  
}

